// localStore 存储信息
// 导入token
const Token = 'Token'
// 导入user用户对象
const User = 'User'

export function getToken () {
  return sessionStorage.getItem(Token) || '123456789'
}
export function setToken (token) {
  return sessionStorage.setItem(Token, token)
}
export function removeToken () {
  return sessionStorage.removeItem(Token)
}
export function getUser () {
  return sessionStorage.getItem(User)
}
export function setUser (user) {
  return sessionStorage.setItem(User, user)
}
export function removeUser () {
  return sessionStorage.removeItem(User)
}
export function pwdValidate (that, pwd) {
  let reg = /^((\d+[A-Za-z]+)|([A-Za-z]+\d+))$/
  if ( reg.test(pwd) ) return true
  that.$message({
    showClose: true,
    message: '请输入正确格式的密码，必须由数字和字母组成!',
    type: 'warn',
    duration: 1000,
  })
  return false
}
